import { onMounted, ref, watch } from "@vue/composition-api";
import { getTextHeight } from "../services/Canvas2DContext";
import { DefaultConfigs, IPadProConfigs } from "../services/DefaultConfigs";

const SPACE = 4;

function shiftYByTextHeight(previousY, labelProps) {
  const textHeight = getTextHeight(`${labelProps.fontWeight} ${labelProps.fontSize}px ${labelProps.fontFamily}`,
    labelProps.text, SPACE);

  return previousY + textHeight;
}

export default function useChartXAxisLabel(configRef, availableWidthRef, marginRef, isIPadProRef) {
  const xAxisLabels = ref([]);

  const updateChartXAxisLabel = () => {
    if (!configRef?.value) {
      return;
    }

    let config = configRef.value?.xAxis?.label ?? {};

    const {
      fontFamily = DefaultConfigs.XAxis.fontFamily,
      fontSize = isIPadProRef?.value ? IPadProConfigs.XAxis.fontSize : DefaultConfigs.XAxis.fontSize,
      fontWeight = DefaultConfigs.XAxis.fontWeight || "",
      textColor = DefaultConfigs.XAxis.textColor,
      textAnchor = DefaultConfigs.XAxis.textAnchor,
      rotate = DefaultConfigs.XAxis.rotate,
    } = config;

    let {
      x = DefaultConfigs.XAxis.x,
      y = DefaultConfigs.XAxis.y,
    } = config;

    if (marginRef.value?.left != null && availableWidthRef.value != null) {
      x = (availableWidthRef.value + marginRef.value.left) / 2;
    }

    const labels = Array.isArray(config.text)
      ? config.text
      : config.text
        ? [config.text]
        : [];

    const noBreakRegex = /<\/?no-break>/g;

    xAxisLabels.value = labels.map(label => {
      let result = {
        fontFamily,
        fontSize,
        textColor,
        fontWeight,
        textAnchor,
        rotate,
        x,
        y,
        text: label,
      };

      if (typeof label === "string") {
        // TODO: adjust superscript tspan with fontSize adjustments
        // based on fontSize set for main label
        // result.text = result.text.replace(supOpenRegex, '<tspan baseline-shift="super">');
        // result.text = result.text.replace(supCloseRegex, "</tpsan>")
        result.text = label.replace(noBreakRegex, "");
      } else {
        result = {
          ...result,
          ...label,
          // we always want to use the computed coordinates
          x,
          y,
        };
      }

      y = shiftYByTextHeight(y, result);

      return result;
    });
  };

  watch([configRef, availableWidthRef, marginRef, isIPadProRef], updateChartXAxisLabel);

  onMounted(updateChartXAxisLabel);

  return { xAxisLabels };
}
